module.exports = __webpack_public_path__ + "img/shock.bdb7c0e5.svg";